export default {
  id: 183,
  title: 'Target #183 - Brazil',
  url: 'https://cssbattle.dev/play/183',
  colors: ['#009B3A', '#FEDF00', '#FFFFFF', '#002776'],
  solution:
    '<p><style>body{background:linear-gradient(33.7deg,#009b3a 153px,transparent 153px),linear-gradient(-33.7deg,#009b3a 153px,transparent 153px),linear-gradient(213.7deg,#009b3a 153px,transparent 153px),linear-gradient(-213.7deg,#009b3a 153px,transparent 153px) #fedf00}p{width:120;height:120;top:74;left:140;border-radius:50%;position:fixed;background:radial-gradient(circle at 30px 140px,#002776 100px,#fff 100px 110px,#002776 110px)}</style>',
}
